import { render, staticRenderFns } from "./ExtAstaDxPreview.vue?vue&type=template&id=fc017906"
import script from "./ExtAstaDxPreview.vue?vue&type=script&lang=js"
export * from "./ExtAstaDxPreview.vue?vue&type=script&lang=js"
import style0 from "./ExtAstaDxPreview.vue?vue&type=style&index=0&id=fc017906&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports